<script>
	import { action } from "../api";
	import { state } from "../store";
	import { positions, Cards } from "./ui";
	import Player from "./player.svelte";
	import Me from "./me.svelte";

	$: players = $state.players;
	$: game = $state.game;
	$: me = players.find((player) => {
		return player.isYou;
	});

	const onCardDrop = (card, position) => {
		if (position.pageX > 0.2 * window.innerWidth
			&& position.pageY  > .33 * window.innerHeight
			&& position.pageX < 0.8 * window.innerWidth
			&& position.pageY  < .66 * window.innerHeight) {
			const index = me.cards.indexOf(card);
			if (index > -1) {
				me.cards.splice(index, 1);
				game.centerCards.push(card);
				action("centerCard", card);
				// make svelte notice the changes
				me = me;
				game = game;
			}
		}
		else if (position.pageX > 0.2 * window.innerWidth
			&& position.pageY  > .66 * window.innerHeight
			&& position.pageX < 0.8 * window.innerWidth) {
			const index = game.centerCards.indexOf(card);
			if (index > -1) {
				game.centerCards.splice(index, 1);
				me.cards.push(card);
				action("takeCard", card);
				// make svelte notice the changes
				me = me;
				game = game;
			}
		}
	}

	const onLivesClick = () => {
		if (me.lives > 0){
			me.lives--;
			action("lives", me.lives);
		}
		else {
			me.isOut = true;
			action("out", me.isOut);
		}
	};

	const onLivesLongClick = () => {
		if (!me.isOut){
			me.lives++;
			action("lives", me.lives);
		}
		else {
			me.isOut = false;
			action("out", me.isOut);
		}
	}

	const onDeal = () => {
		action("deal");
	};

	const onReveal = () => {
		action("reveal");
	};

	const onHide = () => {
		action("hide");
	};

	const onNameChange = (name) => {
		if (name) {
			action("changeName", name);
			me.name = name;
			me = me;
		}
	}

	const onDiscardCards = () => {
		action("chooseCards", true);
	}

	const onKeepCards = () => {
		action("chooseCards", false);
	}
</script>

<div class="table">
	{#each players.map((player) => {
		if (me && player.position < me.position) {
			player.position += 10;
		}
		return player;
	}).sort((player1, player2) => {
		return player1.position - player2.position;
	}).filter(({ isYou }) => !isYou) as player, index (player.id)}
		<Player {player} {index} positions={positions[players.length - (me ? 2 : 1)]} />
	{/each}
	{#if me}
		<div class="me">
			<Me
				{me}
				{onCardDrop}
				{onLivesClick}
				{onLivesLongClick}
				{onDeal}
				{onReveal}
				{onHide}
				{onNameChange}
				{onDiscardCards}
				{onKeepCards}
			/>
		</div>
	{/if}
	<div class="center"><Cards cards={game.centerCards} {onCardDrop} /></div>
</div>

<style>
	.table  {
		display: grid;
		grid-template-columns: repeat(5, 20%);
		grid-template-rows: 25% 42% 33%;
		align-items: center;

		width: 100%;
		height: 100%;
	}

	.me {
		grid-column-start: 2;
		grid-column-end: 5;
		grid-row-start: 3;
		grid-row-end: 4;
	}

	.center {
		grid-column-start: 2;
		grid-column-end: 5;
		grid-row-start: 2;
		grid-row-end: 3;
	}
</style>